import React from 'react';

export default function BookableTag({ isBookable, isComingSoon }) {
  return (
    <div
      className={
        'br5 gSemiBold fs-12 txt-center white ' +
        (isComingSoon
          ? 'sb-active-grey-bg black '
          : isBookable
            ? 'sb-blue-bg '
            : 'light-green-bg ') +
        'pd-2 pd-left-20 pd-right-20 w-fit '
      }
      style={{ lineHeight: 1.7, whiteSpace: 'nowrap' }}
    >
      {isComingSoon ? 'Coming Soon' : isBookable ? 'Bookable' : 'Directory'}
    </div>
  );
}
